module.exports = __webpack_public_path__ + "static/media/cm_main_logo.937be7da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cm_main_logo.svg
// module id = 5747
// module chunks = 11